module.exports = {"id":"176048","name":"Kei Kamara","rating":"74","photo":"./data/images/photos/2/176048.png","club":{"name":"Whitecaps FC","logo":"./data/images/clubs/WhitecapsFC.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KeiKamara0.json
// module id = 2305
// module chunks = 0